module.exports = __webpack_public_path__ + "assets/img/tag-celebration-ba1b1219.png";